const storyPageSlider = {
  exploreStory($sliderID) {
    jQuery($sliderID).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 2000,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  init() {
    if (jQuery("#web_stories").length > 0) {
      this.exploreStory("#web_stories");
    }
  },
};
